import { ActivityInformationHotelModel } from '../api/useActivityInformationHotelQuery';

// Maps a hotel's contact fields to ContactInfoBar props.
export const hotelContactInfo = (hotel: ActivityInformationHotelModel) => ({
  emails: hotel.Email ? [{ Address: hotel.Email, Description: 'Email Address' }] : [],
  phoneNumbers: hotel.PhoneNumber ? [{ Number: hotel.PhoneNumber, Description: 'Phone Number' }] : [],
  faxNumbers: hotel.FaxNumber ? [hotel.FaxNumber] : [],
  website: hotel.Website ? { url: hotel.Website, description: 'Website' } : undefined
});
